import { createFileRoute } from '@tanstack/react-router'
import TrainingOnDemandDetailPage from '@/pages/resources/trainings-on-demand/detail'

export const Route = createFileRoute('/app/resources/trainings-on-demand/$id')({
  component: RouteComponent,
})

function RouteComponent() {
  const { id } = Route.useParams()
  return <TrainingOnDemandDetailPage id={Number(id)} />
}
